<template>
    <div class="onboarding-progress">
        <div class="onboarding-progress__header">
            <img :src="image" :alt="title" :class="imageClass">
            <h1 class="onboarding-progress__title"><slot name="title">{{ title }}</slot></h1>
            <p v-if="responseTime" class="onboarding-progress__response-time">
                <icon name="clock"></icon>
                <span v-html="responseTime"></span>
            </p>
            <p class="onboarding-progress__desc"><slot name="content">{{ description }}</slot></p>
            <div class="onboarding-progress__steps">
                <div class="onboarding-progress__step " :class="(current > index) ? 'active' : ''" v-for="(step, index) in steps" :data-index="index"/>
            </div>
        </div>
        <p class="onboarding-progress__steps-count">{{ $t( 'onboarding.step' ) + ' ' + current + ' ' + $t( 'onboarding.of' ) + ' ' + steps.length }}</p>
        <h2 class="onboarding-progress__steps-name">{{ steps[ current - 1 ] }}</h2>
    </div>
</template>

<script>
export default {
    name: "onboarding-progress",
    props: {
        image: String,
        imageClass: {
            type: String,
            default: "onboarding-progress__image"
        },
        title: String,
        description: String,
        steps: Array,
        current: Number,
        responseTime: String
    },
}
</script>

<style scoped>
.onboarding-progress__response-time {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #454545;
    font-size: 14px;
    margin-bottom: 0.5rem;
}
.onboarding-progress__response-time svg{
    width: 15px;
    height: 15px;
    margin-right: 4px;
}
</style>
